import { useParams, Navigate } from "react-router-dom";
import { useApplicationResolve } from "@/lib/queries";
import ApplicationDetail from "@/pages/ApplicationDetail";
import ApplicationsDistrict from "@/pages/ApplicationsDistrict";
import NotFound from "@/pages/NotFound";

export default function ApplicationResolver() {
  const { slug } = useParams();
  const { data, isLoading, isError } = useApplicationResolve(slug);

  if (isError) return <NotFound />;
  if (isLoading || !data) return <div className="flex min-h-screen items-center justify-center text-neutral-500">Yükleniyor…</div>;

  if (data.kind === "redirect") return <Navigate to={`/uygulamalar/${data.data.slug}`} replace />;
  if (data.kind === "district") return <ApplicationsDistrict data={data.data} />;
  return <ApplicationDetail app={data.data} />;
}
